import { StartSessionAndGetSessionTokenResponseBody } from '../types/generated/sessionStart_post.response';
import { StartSessionAndGetSessionTokenContentBody } from '../types/generated/sessionStart_post.content';
import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestStart = (
  body: StartSessionAndGetSessionTokenContentBody
): Promise<StartSessionAndGetSessionTokenResponseBody> =>
  fetcher<StartSessionAndGetSessionTokenResponseBody>(
    apiEndpoints.routes.start,
    'POST',
    null,
    undefined,
    undefined,
    body
  );
